import React, { createContext, useCallback, useContext, useState } from 'react';

const STORAGE_KEY = 'sidebar_collapsed';

const SidebarContext = createContext({
  collapsed: false,
  toggleSidebar: () => {},
});

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  const toggleSidebar = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      } catch {}
      return next;
    });
  }, []);

  return (
    <SidebarContext.Provider value={{ collapsed, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebarCollapse() {
  return useContext(SidebarContext);
}

export default SidebarContext;
